import { render, staticRenderFns } from "./deleteAStaffCommunity.vue?vue&type=template&id=764ecb21"
import script from "./deleteAStaffCommunity.vue?vue&type=script&lang=js"
export * from "./deleteAStaffCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports